import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: `tendbot-app@${__APP_VERSION__}`,
  sendDefaultPii: true,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    // Forward console.warn / console.error to Sentry Logs for context around errors.
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
  ],

  // Logs — structured logs alongside errors (used by consoleLoggingIntegration).
  enableLogs: true,

  // Tracing — conservative for free tier
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/api\.tend\.bot/],

  // Session Replay — only record error sessions on free tier
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,

  // Known noise we can't act on — browser quirks, user-cancel flows, and third-party.
  ignoreErrors: [
    // iOS fetch network failure — already surfaced to user via error UI
    'TypeError: Load failed',
    'Load failed',
    // framer-motion race with browser autofill / mobile password manager during commit
    /NotFoundError:.*object can not be found/i,
    // Apple Sign-In cancel (error code 1000 = unknown, usually tap-outside on iOS 18)
    /AuthenticationServices\.AuthorizationError error (1000|1001)/,
  ],
})
